export default {
  monthly: 'MonthlyStartup',
  quarterly: 'QuarterlyStartup',
  yearly: 'YearlyStartup',
  coupon: 'Coupon',
};
